export class Constants {
    public static readonly PreloadedDataStore = "preloadedData";
    public static readonly PricePresentationDataKey = "PricePresentation";
    public static readonly SlidingScalesDataKey = "SlidingScales";
    public static readonly ReferralsDataKey = "Referrals";
    public static readonly MinimumsDataKey = "Minimums";
    public static readonly ValuePercentagesDataKey = "ValuePercentages";
}